import controller from './dashboard.controller';
import template from './dashboard.pug';

const DashboardComponent = {
  template,
  controller,
};

export default DashboardComponent;



// WEBPACK FOOTER //
// ./client/app/dashboard/dashboard.component.js